import { Dtos, ErrorKey, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { ApiError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { bondRequestIssuanceQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useFetchBondIssuance = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const queryClient = useQueryClient();
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestIssuanceQueryKey(quoteId),
		queryFn: async () => {
			try {
				return await get<Dtos.SuretyBondIssuance.Get.Response>(
					`/v2/surety/accounts/${accountId}/quotes/${quoteId}/issuance`,
				);
			} catch (error) {
				if (error instanceof ApiError && error.key === ErrorKey.bond_request_already_closed) {
					return null;
				}
				throw error;
			}
		},
		retry: false,
		meta: { redirectOnError: redirectToIssuedBond },
	});

	useEffect(() => {
		if (data !== null) return;
		void queryClient.invalidateQueries({
			queryKey: bondRequestsQueryKey(quoteId),
			exact: true,
		});
	}, [data, queryClient, quoteId]);

	return {
		bondIssuance: data,
		bondIssuanceError: error,
		bondIssuanceIsLoading: isLoading,
	};
};
